import { $ } from 'utils/dom';
import ScrollClassToggler from 'modules/scroll-class-toggler';

const logo = $('.logo-fixed');
const classToAdd = 'logo-fixed--is-hidden';

if (logo) {
  const toggleLogoClass = new ScrollClassToggler(logo, classToAdd, 50, 50);

  toggleLogoClass.init();
}
